import { useMemo, useState } from 'react';
import { DropdownOption } from 'uikit/inputs/dropdown/appDropdownInput';
import { useGetDoctorStudyByIdQuery } from 'src/services/api/api-client/StudyQuery';
import { useGetMonitoringFormConfigQuery } from 'src/services/api/api-client/ConfigurableMonitoringFormsQuery';
import { useStudy } from 'src/helpers/hooks/useStudy';

export const useMonitoringFormSelector = (options?: { enabled?: boolean }) => {
  const study = useStudy();
  const doctorStudy = useGetDoctorStudyByIdQuery({ id: study!.id }, { enabled: !!study?.id });
  const [selectedConfigId, setConfigId] = useState<number>();

  const formConfigQuery = useGetMonitoringFormConfigQuery(
    { formId: selectedConfigId ?? 0 },
    { refetchOnMount: 'always', enabled: options?.enabled && !!selectedConfigId },
  );

  const configList = useMemo(
    () =>
      doctorStudy.data?.monitoringFormConfigs.map(
        (c) =>
          ({
            key: c.configId,
            text: c.title,
          } satisfies DropdownOption<number>),
      ) ?? [],
    [doctorStudy.data?.monitoringFormConfigs],
  );

  const selectedConfig = useMemo(
    () => (selectedConfigId ? formConfigQuery.data : undefined),
    [formConfigQuery.data, selectedConfigId],
  );

  const selectorProps = {
    options: configList,
    value: configList.find((x) => x.key === selectedConfigId),
    onChange: (o: any) => setConfigId(o ? o.key : undefined),
  };

  return { setConfigId, formConfigQuery, selectedConfig, selectorProps };
};
